document.addEventListener('DOMContentLoaded', function() {
    console.log("Upsell script loaded");
    console.log("window.upsellHandle:", window.upsellHandle);
    
    // Check if upsell handle exists
    if (typeof window.upsellHandle === 'undefined' || !window.upsellHandle) {
        console.log('No upsell handle found - check your product tags');
        console.log('Make sure the product has a tag like: upsell:product-handle');
        return;
    }

    const upsellHandle = window.upsellHandle;
    let upsellProduct = null;
    let isUpsellShown = false;
    let isProcessing = false;
    let pendingFormSubmit = null;
    let mainProductAdded = false; // Track if main product was added

    console.log("Upsell handle found:", upsellHandle);

    // Get the form
    const productForm = document.getElementById('product-form');
    if (!productForm) {
        console.log('Product form not found - check ID "product-form"');
        return;
    }
    
    console.log("Product form found");

    // Get upsell modal elements
    const overlay = document.getElementById('upsell-overlay');
    if (!overlay) {
        console.log('Upsell overlay not found - check HTML structure');
        return;
    }
    
    console.log("Upsell overlay found");

    // Simple price formatter
    function formatPrice(price) {
        // price is in cents
        return '$' + (price / 100).toFixed(2);
    }

    // INTERCEPT FORM SUBMISSION
    productForm.addEventListener('submit', function(e) {
        console.log("Form submission intercepted");
        
        // If main product was already added, prevent duplicate
        if (mainProductAdded) {
            console.log("Main product already added, preventing duplicate submission");
            e.preventDefault();
            return;
        }

        // If we're already processing or showing upsell, let it handle
        if (isProcessing || isUpsellShown) {
            console.log("Already processing or showing upsell");
            e.preventDefault();
            return;
        }

        // Prevent default form submission
        e.preventDefault();
        isProcessing = true;

        // Store form data for later use
        pendingFormSubmit = new FormData(productForm);

        // Check if upsell product is already fetched
        if (upsellProduct === null) {
            fetchUpsellProduct().then(product => {
                if (product) {
                    showUpsellModal(product);
                } else {
                    // No upsell found, add main product
                    console.log("No upsell product found, adding main product");
                    addMainProduct();
                    isProcessing = false;
                }
            }).catch(() => {
                addMainProduct();
                isProcessing = false;
            });
            return;
        }

        // If upsell product exists but not shown yet
        if (!isUpsellShown && upsellProduct) {
            showUpsellModal(upsellProduct);
            isProcessing = false;
        } else {
            // No upsell, add main product
            addMainProduct();
            isProcessing = false;
        }
    });

    // Fetch upsell product data
    function fetchUpsellProduct() {
        console.log("Fetching upsell product:", upsellHandle);
        return fetch('/products/' + upsellHandle + '.js')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Product not found: ' + upsellHandle);
                }
                return response.json();
            })
            .then(product => {
                upsellProduct = product;
                console.log('Upsell product loaded:', product.title);
                return product;
            })
            .catch(error => {
                console.error('Error fetching upsell product:', error);
                return null;
            });
    }

    // Show upsell modal
    function showUpsellModal(product) {
        if (!product) {
            console.log('No product to show in modal');
            return;
        }

        console.log("Showing upsell modal for:", product.title);

        const overlay = document.getElementById('upsell-overlay');
        if (!overlay) {
            console.log('Upsell overlay not found');
            return;
        }

        // Populate modal with product data
        const imageEl = document.getElementById('upsell-image');
        const titleEl = document.getElementById('upsell-title');
        const priceEl = document.getElementById('upsell-price');
        const descEl = document.getElementById('upsell-description');

        if (imageEl) {
            imageEl.src = product.featured_image || '';
            imageEl.alt = product.title || '';
            console.log("Image set:", imageEl.src);
        }

        if (titleEl) {
            titleEl.textContent = product.title || '';
            console.log("Title set:", titleEl.textContent);
        }

        if (priceEl) {
            const variant = product.variants && product.variants[0] ? product.variants[0] : null;
            if (variant) {
                // Use simple price formatter
                let priceHTML = formatPrice(variant.price);
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    priceHTML += ' <span class="was-price">Was ' + formatPrice(variant.compare_at_price) + '</span>';
                }
                priceEl.innerHTML = priceHTML;
                console.log("Price set:", priceHTML);
            } else {
                priceEl.textContent = 'Price not available';
            }
        }

        if (descEl) {
            // Strip HTML from description
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product.description || '';
            descEl.textContent = tempDiv.textContent || tempDiv.innerText || '';
            // Truncate description
            if (descEl.textContent.length > 150) {
                descEl.textContent = descEl.textContent.substring(0, 150) + '...';
            }
            console.log("Description set");
        }

        // Show overlay
        overlay.style.display = 'flex';
        setTimeout(() => {
            overlay.style.opacity = '1';
        }, 10);

        isUpsellShown = true;
        isProcessing = false;
        console.log('Upsell modal shown successfully');
        
        // Log the overlay display style to confirm
        console.log('Overlay display style:', overlay.style.display);
        console.log('Overlay opacity:', overlay.style.opacity);
    }

    // Hide upsell modal
    function hideUpsellModal() {
        const overlay = document.getElementById('upsell-overlay');
        if (overlay) {
            overlay.style.opacity = '0';
            setTimeout(() => {
                overlay.style.display = 'none';
            }, 300);
        }
        isUpsellShown = false;
    }

    // Add ONLY the upsell product (not the main product)
    function addUpsellToCart() {
        if (!upsellProduct) {
            console.error('No upsell product available');
            return;
        }

        const variantId = upsellProduct.variants && upsellProduct.variants[0] ? upsellProduct.variants[0].id : null;
        if (!variantId) {
            console.error('No variant found for upsell product');
            return;
        }

        console.log("Adding upsell product to cart:", variantId);

        // Show loading state
        const addBtn = document.getElementById('upsell-add');
        if (addBtn) {
            addBtn.textContent = 'Adding...';
            addBtn.disabled = true;
        }

        // Add ONLY upsell product to cart using Shopify's AJAX API
        const data = {
            id: variantId,
            quantity: 1
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add upsell product to cart');
            }
            return response.json();
        })
        .then(() => {
            console.log('Upsell product added to cart');
            hideUpsellModal();
            
            // Show success message
            showUpsellSuccessMessage('Upsell product added to cart!');
            
            // DO NOT add the main product again - it was already added when the popup appeared
            // Just redirect to cart after a delay
            setTimeout(() => {
                window.location.href = '/cart';
            }, 1500);
        })
        .catch(error => {
            console.error('Error adding upsell product:', error);
            hideUpsellModal();
            showUpsellSuccessMessage('Error adding upsell product', false);
            // Still redirect to cart since main product was already added
            setTimeout(() => {
                window.location.href = '/cart';
            }, 1500);
        })
        .finally(() => {
            if (addBtn) {
                addBtn.textContent = 'Add To My Order';
                addBtn.disabled = false;
            }
        });
    }

    // Add ONLY the main product
    function addMainProduct() {
        // Prevent duplicate main product additions
        if (mainProductAdded) {
            console.log("Main product already added, skipping");
            return;
        }

        if (!productForm) {
            console.error('Product form not found');
            return;
        }

        console.log("Adding main product");

        // Use the stored form data or get fresh data
        const formData = pendingFormSubmit || new FormData(productForm);
        pendingFormSubmit = null;
        
        const data = {};
        
        // Extract form data
        for (const [key, value] of formData.entries()) {
            if (key === 'id') {
                data.id = parseInt(value);
            } else if (key === 'quantity') {
                data.quantity = parseInt(value);
            } else if (key.startsWith('properties[')) {
                if (!data.properties) data.properties = {};
                data.properties[key] = value;
            }
        }

        // Default quantity if not set
        if (!data.quantity) data.quantity = 1;

        console.log('Adding main product:', data);

        // Mark as added to prevent duplicates
        mainProductAdded = true;

        // Use Shopify's AJAX API
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add product to cart');
            }
            return response.json();
        })
        .then(() => {
            console.log('Main product added to cart successfully');
            // Don't show success message here - let the upsell flow handle it
        })
        .catch(error => {
            console.error('Error adding main product to cart:', error);
            // Fallback to form submit
            productForm.submit();
        });
    }

    // Show success message
    function showUpsellSuccessMessage(message, isSuccess = true) {
        const existingMsg = document.querySelector('.upsell-success-msg');
        if (existingMsg) existingMsg.remove();

        const successMsg = document.createElement('div');
        successMsg.className = 'upsell-success-msg';
        successMsg.style.cssText = `position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); background: ${isSuccess ? '#4CAF50' : '#f44336'}; color: white; padding: 15px 30px; border-radius: 8px; text-align: center; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.2); font-weight: bold;`;
        successMsg.textContent = message;
        document.body.appendChild(successMsg);

        setTimeout(() => {
            successMsg.style.opacity = '0';
            successMsg.style.transition = 'opacity 0.5s ease';
            setTimeout(() => {
                successMsg.remove();
            }, 500);
        }, 3000);
    }

    // Also intercept the add to cart button click as a backup
    const addToCartBtn = document.getElementById('purchase');
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function(e) {
            console.log("Add to cart button clicked - triggering form submit");
            // This will trigger the form submit event
            productForm.dispatchEvent(new Event('submit', { cancelable: true }));
        });
    }

    // Event listeners for upsell buttons
    const addBtn = document.getElementById('upsell-add');
    const skipBtn = document.getElementById('upsell-skip');
    const viewBtn = document.getElementById('upsell-view');

    if (addBtn) {
        addBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (!isProcessing) {
                isProcessing = true;
                addUpsellToCart();
            }
        });
        console.log("Add button listener attached");
    } else {
        console.log("Upsell add button not found");
    }

    if (skipBtn) {
        skipBtn.addEventListener('click', function(e) {
            e.preventDefault();
            hideUpsellModal();
            isProcessing = false;
            // Add main product if not already added
            if (!mainProductAdded) {
                addMainProduct();
            }
            // Redirect to cart
            setTimeout(() => {
                window.location.href = '/cart';
            }, 1000);
        });
        console.log("Skip button listener attached");
    } else {
        console.log("Upsell skip button not found");
    }

    if (viewBtn) {
        viewBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (upsellProduct) {
                window.location.href = '/products/' + upsellProduct.handle;
            }
        });
        console.log("View button listener attached");
    } else {
        console.log("Upsell view button not found");
    }

    // Close modal on overlay click
    if (overlay) {
        overlay.addEventListener('click', function(e) {
            if (e.target === this) {
                hideUpsellModal();
                isProcessing = false;
                // Add main product if not already added
                if (!mainProductAdded) {
                    addMainProduct();
                }
                // Redirect to cart
                setTimeout(() => {
                    window.location.href = '/cart';
                }, 1000);
            }
        });
        console.log("Overlay click listener attached");
    }

    // Handle keyboard escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isUpsellShown) {
            hideUpsellModal();
            isProcessing = false;
            // Add main product if not already added
            if (!mainProductAdded) {
                addMainProduct();
            }
            // Redirect to cart
            setTimeout(() => {
                window.location.href = '/cart';
            }, 1000);
        }
    });

    // Pre-fetch upsell product on page load for faster loading
    if (upsellHandle) {
        fetchUpsellProduct();
    }

    console.log('Upsell functionality initialized successfully');
});